import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { PeriodLockIcon } from "@components/periodLock/PeriodLockIcon";
import { MatchableItem } from "../types";
import {
    getMatchItemLockedLabel,
    useIsMatchableItemLocked,
} from "../matchLock";

/**
 * Read-only period-lock indicator for the match drawer's source/selected/
 * search rows (PRO-12200). Mirrors the Invoices/Bills tables' `LockCell`:
 * shown once the item's own date falls inside its entity's locked
 * accounting period. Uses the item's own `entityId` (the document/
 * transaction's owning entity), not `ledgerEntityId`, matching how the
 * Invoices/Bills list locks are keyed.
 */
export const LockCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        const item = row.original;
        const isLocked = useIsMatchableItemLocked(item);

        if (row.depth > 0 || !isLocked) {
            return null;
        }

        return (
            <PeriodLockIcon
                label={getMatchItemLockedLabel(item.type)}
                testId="accrual-match-lock"
            />
        );
    },
);
LockCell.displayName = "AccrualMatchLockCell";
